import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './ResponsiveContent.scss';

/**
 * ResponsiveContent allows elements to maintain their aspect ratio
 * across various screen sizes and is stable to load-time changes, like image loading.
 * https://www.andyshora.com/css-image-container-padding-hack.html
 */
const ResponsiveContent = ({ width = 0, height, children, className = '' }) => (
    <div
        className={getClassName(styles.wrapper, className)}
        style={
            width
                ? { paddingTop: `${(height / width) * 100}%` }
                : { height: `${height}px` }
        }
    >
        <div className={styles.content}>{children}</div>
    </div>
);

export default ResponsiveContent;
